import { Guid } from 'guid-typescript';

export class LoadingAnimationManager {
  private toggleLoadingAnimation: ((isVisible: boolean, id: string) => void) | null = null;

  private instanceId: string = Guid.create().toString();

  setToggleFunction(toggleFn: (isVisible: boolean, id: string) => void) {
    this.toggleLoadingAnimation = toggleFn;
  }

  showLoading() {
    if (this.toggleLoadingAnimation) {
      this.toggleLoadingAnimation(true, this.instanceId);
    }
  }

  hideLoading() {
    if (this.toggleLoadingAnimation) {
      this.toggleLoadingAnimation(false, this.instanceId);
    }
  }
}
